module.exports = __webpack_public_path__ + "img/folding.4af4a25.svg";